"use strict";
exports.__esModule = true;
exports.Api = void 0;
var tslib_1 = require("tslib");
/* tslint:disable */
require("isomorphic-fetch");
var ApiError = /** @class */ (function () {
    function ApiError(message) {
        this.details = null;
        this.message = message;
    }
    return ApiError;
}());
/**
 * Eshop RESTful API specification.

 * @class Api
 * @param {(string)} [domainOrOptions] - The project domain.
 */
var Api = /** @class */ (function () {
    function Api() {
        this.baseUrl = 'https://eshop.sportnet.online/api/v2';
        this.token = '';
    }
    Api.prototype.serializeQueryParams = function (parameters) {
        return Object.keys(parameters)
            .reduce(function (acc, p) {
            var param = parameters[p];
            if (typeof param === 'undefined' || param === '') {
                return acc;
            }
            return tslib_1.__spreadArrays(acc, [
                encodeURIComponent(p) + "=" + encodeURIComponent(String(parameters[p])),
            ]);
        }, [])
            .join('&');
    };
    Api.prototype.transformParameter = function (value, transformOperation) {
        switch (transformOperation) {
            case 'joinUsingPipes':
                return Array.isArray(value) ? value.join('|') : value;
            default:
                return value;
        }
    };
    Api.prototype.setBaseUrl = function (baseUrl) {
        this.baseUrl = baseUrl;
    };
    Api.prototype.setToken = function (token) {
        this.token = token;
    };
    Api.prototype.appendAuthHeaders = function (headerParams) {
        var headers = new Headers(headerParams);
        if (this.token) {
            headers.append('Authorization', "Bearer " + this.token);
        }
        return headers;
    };
    Api.prototype.request = function (method, url, body, headers, queryParameters) {
        if (headers === void 0) { headers = new Headers(); }
        if (queryParameters === void 0) { queryParameters = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryParams, urlWithParams, form, k, response, responseContentType, err, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        queryParams = queryParameters && Object.keys(queryParameters).length
                            ? this.serializeQueryParams(queryParameters)
                            : null;
                        urlWithParams = url + (queryParams ? '?' + queryParams : '');
                        if (headers.get('Content-Type') === 'multipart/form-data') {
                            form = new FormData();
                            for (k in body) {
                                form.append(k, body[k]);
                            }
                            body = form;
                        }
                        else if (headers.get('Content-Type') === 'application/json' &&
                            body &&
                            Object.keys(body).length > 0) {
                            body = JSON.stringify(body);
                        }
                        else {
                            body = undefined;
                        }
                        if (headers.get('Content-Type') === 'multipart/form-data') {
                            headers["delete"]('Content-Type');
                        }
                        return [4 /*yield*/, fetch(urlWithParams, { method: method, headers: headers, body: body })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) return [3 /*break*/, 2];
                        responseContentType = (response.headers && response.headers.get('Content-Type')) || '';
                        if (responseContentType.includes('application/json')) {
                            return [2 /*return*/, response.json()];
                        }
                        else if (responseContentType.includes('application/pdf')) {
                            return [2 /*return*/, response.blob()];
                        }
                        else if (responseContentType.includes('text/plain')) {
                            return [2 /*return*/, response.text()];
                        }
                        return [2 /*return*/, {}];
                    case 2:
                        err = new ApiError(response.statusText);
                        _a = err;
                        return [4 /*yield*/, response.json()];
                    case 3:
                        _a.details = _b.sent();
                        throw err;
                }
            });
        });
    };
    /**
     *
     * @method
     * @name Api#publicListSaleschannels
     */
    Api.prototype.publicListSaleschannels = function (appSpace, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannels/{appSpace}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * Get eshop's saleschannel settings (saleschannel detail)
     * @method
     * @name Api#saleschannelGetSettings
     */
    Api.prototype.saleschannelGetSettings = function (appSpace, saleschannel, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * Get listings for eshop's saleschannel
     * @method
     * @name Api#saleschannelGetListings
     */
    Api.prototype.saleschannelGetListings = function (appSpace, saleschannel, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/listings';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * https://support.google.com/google-ads/answer/6053288
     * @method
     * @name Api#saleschannelProductsFeedGoogleAds
     */
    Api.prototype.saleschannelProductsFeedGoogleAds = function (appSpace, saleschannel, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/feed/google-ads';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'text/csv');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * https://developers.facebook.com/docs/marketing-api/dynamic-product-ads/product-catalog#create-product-catalog
     * @method
     * @name Api#saleschannelProductsFeedFacebook
     */
    Api.prototype.saleschannelProductsFeedFacebook = function (appSpace, saleschannel, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/feed/facebook';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'text/csv');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * Get list of products based on varios filters. Multiple search parameter values are separated with pipe.
     * @method
     * @name Api#saleschannelSearchProducts
     */
    Api.prototype.saleschannelSearchProducts = function (appSpace, saleschannel, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/products';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        queryParameters['offset'] = 0;
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['q'] !== 'undefined') {
            queryParameters['q'] = parameters['q'];
        }
        queryParameters['q'] = this.transformParameter(queryParameters['q']);
        if (typeof parameters['tags'] !== 'undefined') {
            queryParameters['tags'] = parameters['tags'];
        }
        queryParameters['tags'] = this.transformParameter(queryParameters['tags']);
        if (typeof parameters['listings'] !== 'undefined') {
            queryParameters['listings'] = parameters['listings'];
        }
        queryParameters['listings'] = this.transformParameter(queryParameters['listings']);
        if (typeof parameters['brands'] !== 'undefined') {
            queryParameters['brands'] = parameters['brands'];
        }
        queryParameters['brands'] = this.transformParameter(queryParameters['brands']);
        if (typeof parameters['categories'] !== 'undefined') {
            queryParameters['categories'] = parameters['categories'];
        }
        queryParameters['categories'] = this.transformParameter(queryParameters['categories']);
        if (typeof parameters['exclude'] !== 'undefined') {
            queryParameters['exclude'] = parameters['exclude'];
        }
        queryParameters['exclude'] = this.transformParameter(queryParameters['exclude']);
        queryParameters['sorter'] = '-categoryPriority.priority';
        if (typeof parameters['sorter'] !== 'undefined') {
            queryParameters['sorter'] = parameters['sorter'];
        }
        queryParameters['sorter'] = this.transformParameter(queryParameters['sorter']);
        if (typeof parameters['params'] !== 'undefined') {
            queryParameters['params'] = parameters['params'];
        }
        queryParameters['params'] = this.transformParameter(queryParameters['params']);
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        if (typeof parameters['businessNr'] !== 'undefined') {
            queryParameters['businessNr'] = parameters['businessNr'];
        }
        queryParameters['businessNr'] = this.transformParameter(queryParameters['businessNr']);
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#saleschannelGetProductDetail
     */
    Api.prototype.saleschannelGetProductDetail = function (appSpace, saleschannel, productId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/products/{product_id}';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        if (typeof parameters['businessNr'] !== 'undefined') {
            queryParameters['businessNr'] = parameters['businessNr'];
        }
        queryParameters['businessNr'] = this.transformParameter(queryParameters['businessNr']);
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        path = path.replace('{product_id}', productId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#saleschannelGetRelatedProducts
     */
    Api.prototype.saleschannelGetRelatedProducts = function (appSpace, saleschannel, productId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/products/{product_id}/related';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        queryParameters['limit'] = 100;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        queryParameters['offset'] = 0;
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        if (typeof parameters['businessNr'] !== 'undefined') {
            queryParameters['businessNr'] = parameters['businessNr'];
        }
        queryParameters['businessNr'] = this.transformParameter(queryParameters['businessNr']);
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        path = path.replace('{product_id}', productId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#saleschannelGetRootCategories
     */
    Api.prototype.saleschannelGetRootCategories = function (appSpace, saleschannel, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/categories';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#saleschannelGetCategories
     */
    Api.prototype.saleschannelGetCategories = function (appSpace, saleschannel, categoryId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/categories/{category_id}';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        path = path.replace('{category_id}', categoryId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#saleschannelGetCategorySearchParams
     */
    Api.prototype.saleschannelGetCategorySearchParams = function (appSpace, saleschannel, categoryId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/categories/{category_id}/searchparams';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        path = path.replace('{category_id}', categoryId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#saleschannelGetCategoriesTree
     */
    Api.prototype.saleschannelGetCategoriesTree = function (appSpace, saleschannel, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/categories-tree';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     *
     * @method
     * @name Api#saleschannelGetBrands
     */
    Api.prototype.saleschannelGetBrands = function (appSpace, saleschannel, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/saleschannel/{appSpace}/{saleschannel}/brands';
        var headers = new Headers();
        var queryParameters = {};
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{appSpace}', appSpace.toString());
        path = path.replace('{saleschannel}', saleschannel.toString());
        if (typeof parameters['categories'] !== 'undefined') {
            queryParameters['categories'] = parameters['categories'];
        }
        queryParameters['categories'] = this.transformParameter(queryParameters['categories']);
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    return Api;
}());
exports.Api = Api;
exports["default"] = new Api();
